import { DictionaryPage } from 'components/pages'

export const SettingDictionaryPage = () => {
  return <DictionaryPage />
}
